import { render, staticRenderFns } from "./ReportsMenu.vue?vue&type=template&id=1ca28b00"
import script from "./ReportsMenu.vue?vue&type=script&lang=js"
export * from "./ReportsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports